module.exports = __webpack_public_path__ + "static/media/6.748e7fa6.svg";